import React, { useMemo } from "react";
import useTableInstance from "hooks/useTableInstance";
import Pagination from "components/Common/Pagination/index";
import TableContainer from "./TableContainerResultEntryInsideRow";
import "../../../styles/components/table.scss";

const EMPTY_TABLE_DATA = [];

function Table(props) {
  const {
    data: tableData,
    isLoading,
    tableColumns,
    TableColumnFilter,
    enableSorting = false,
    currentPage,
    disablePrev,
    disableNext,
    totalPages,
    loadNextPage,
    loadPreviousPage,
    totalRecords,
    showPagination = true,
    getRowProps = () => ({}),
    renderExpandedRow,
    expandedRowId,
    setExpandedRowId,
  } = props;
  const safeTableData =
    Array.isArray(tableData) && tableData.length > 0
      ? tableData
      : EMPTY_TABLE_DATA;
  const defaultColumn = useMemo(
    () => ({
      Filter: TableColumnFilter,
    }),
    [],
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    paginationPageRows,
    prepareRow,
  } = useTableInstance(tableColumns, safeTableData, defaultColumn, enableSorting);

  return (
    <>
      <TableContainer
        getRowProps={getRowProps}
        headerGroups={headerGroups}
        getTableBodyProps={getTableBodyProps}
        rows={paginationPageRows}
        getTableProps={getTableProps}
        prepareRow={prepareRow}
        isLoading={isLoading}
        totalRecords={totalRecords}
        tableData={safeTableData}
        renderExpandedRow={renderExpandedRow}
        expandedRowId={expandedRowId}
        setExpandedRowId={setExpandedRowId}
      />
      {safeTableData.length !== 0 && showPagination && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          loadPreviousPage={loadPreviousPage}
          loadNextPage={loadNextPage}
          disablePrev={disablePrev}
          disableNext={disableNext}
        />
      )}
    </>
  );
}

export default Table;
